<template>
  <div>
    <div class="footerLinks-item-title">LINE公式アカウント</div>
    <p class="footerLinks-item-text">定期的にお得な情報配信中！</p>
    <a href="https://lin.ee/BSP3yfR" @click="buttonClicked">
      <common-lazy-load-image
        :image-object="{ width: 116, height: 36 }"
        :is-fixed-dimension="true"
        alt="友だち追加"
        image-url="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png"
        background-color="none"
      />
    </a>
  </div>
</template>

<script>
import GTM from '@/utils/tracking/gtm'
const CommonLazyLoadImage = defineAsyncComponent(() => import('@/components/CommonLazyLoadImage.vue'))
import { MJ_LINE_BUTTON_CLICK } from '@/utils/constants/gaCustomEventSet'
export default {
  components: { CommonLazyLoadImage },
  props: {
    displayBorderBg: { type: Boolean, default: true, required: false }
  },
  methods: {
    buttonClicked() {
      GTM.sendEventToGa({ ...MJ_LINE_BUTTON_CLICK, label: 'LINE友だち追加ボタン押下' })
    }
  }
}
</script>

<style lang="scss" scoped>
.footerLinks {
  &-item {
    &-title {
      font-size: 1.8rem;
      font-weight: bold;
      margin-bottom: 1rem;
    }
    &-text {
      font-size: 1.2rem;
      margin-bottom: 1.6rem;
      @include sp {
        display: inline-block;
        width: 100%;
      }
    }
  }
}
</style>
